import { z } from 'zod'

export const schema = z.array(
  z.object({
    provinceName: z.string(),
    villageName: z.string(),
    image: z.string(),
    url: z.string(),
    maxCapacity: z.number(),
    rating: z.object({
      rating: z.number(),
      votes: z.number(),
    }),
    priceAverage: z.number(),
    priceSummary: z
      .object({
        price: z.number().nullable(),
        type: z.union([z.literal('from'), z.literal('exact')]).nullable(),
      })
      .nullable(),
  }),
)

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  capacity: z.string().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
